// extracted by mini-css-extract-plugin
module.exports = {"close":"Modal_close__t893Z","title":"Modal_title__10NDA"};